/*
 * @Description: 
 * @Author: 长老
 * @Date: 2019-10-25 11:23:52
 * @lastTime     : 2020-02-06 16:01:43
 * @LastAuthor: WE1ZHANTA0
 */
import axios from 'axios'
import YunJi from '@/assets/js/YunJi'
import { Toast } from 'mint-ui'

const market = `//${window.globalConfig.yunjimarketingapp}/yunjimarketingapp/app`
const ys = `//${window.globalConfig.ysappItemBasePath}/yunjiysapp/app`
const wxcallback = `//${window.globalConfig.wxcallback}/yunjitiapp/app`
const userPath = `//${window.globalConfig.userPath}/yunjiuserapp`

const Http = (function() {
  const instance = axios.create({
    withCredentials: true
  })
  
  instance.interceptors.response.use((res) => {
    if (res.data.errorCode == 2418) {
      let returnUrl = window.location.href
      let jumpUrl = '//' + window.globalConfig.linkBasePath + '/yunjibuyer/getVueUser.xhtml?returnUrl=' + encodeURIComponent(returnUrl+'&authorize=true')
      // if (YunJi.getCookie('YUNJI_WEChAT_AYTHOTIZED')) {
      //   window.location.href = jumpUrl
      // } else {
      //   window.location.href = "//"+ window.globalConfig.linkBasePath + "/basecomponents/weChatAuthorized.html?returnUrl="+encodeURIComponent(jumpUrl) + "&titleName=云集"
      // }
      try {
        var modal = new Modal({
          title: '云集',
          returnUrl: jumpUrl
        })
      } catch (error) {
        window.location.href = jumpUrl
      }
    }
    return res.data
  }, (error) => {
    Toast('网络错误')
    return Promise.reject(error)
  })

  instance.interceptors.request.use((config) => {
    let appCont = YunJi.getUrlParams('appCont')
    let ticket = YunJi.getUrlParams('ticket') || '100'
    if (+appCont === 7 && config.params) {
      config.params.ticket = ticket
      config.params.appCont = appCont
    }
    return config
  })

  return instance
})()

/**
 * 获取领取信息数据
 * API文档：http://172.16.0.12/showdoc/index.php?s=/%7F&page_id=5569
 */
export const getCoupon = params => Http.get(market + '/getCoupon.json', { params })
export const getRecommendItemIds = params => Http.get(market + '/couponRecommendItemIds.json', { params })
export const getPersonalItemByCoupon = params => Http.get(market + '/getPersonalItemByCoupon.json', { params })
export const getBatchItemByIds = params => Http.get(market + '/batchItemByIds.json', { params })

export const getCouponShare = params => Http.get(market + '/couponShare.json', { params })
export const getClickCouponShare = params => Http.get(market + '/getCouponShare.json', { params })
export const getDetailVO = params => Http.get(market + '/getDetailVO.json', { params })
export const getCoinRecommendItemIds = params => Http.get(market + '/coinRecommendItemIds.json', { params })
export const getPersonalItemByCoin = params => Http.get(market + '/getPersonalItemByCoin.json', { params })
export const switchPersonalItemByCoupon = params => Http.get(market + '/switchPersonalItemByCoupon.json', { params })

export const queryNavigationItemList = params => Http.get(ys + '/miniprogram/queryNavigationItemList.json', { params })


export const queryNavigationItemListB = params => Http.get(wxcallback + '/item/list.json', { params })

export const queryResourcebit = params => Http.get(wxcallback + '/resourcebit/config.json', { params })

export const queryCoupon = params => Http.get(wxcallback + '/item/coupon.json', { params })

export const toSubscribe = params => Http.get(market + '/usercoupon/notifyValid/subscribe.json', { params })

export const judgeMemberRegister = params => Http.get(userPath + '/userapp/judgeMemberRegister.json', { params })

export const generateSmsCodeCommon = params => Http.get(userPath + '/userapp/generateSmsCodeCommon.json', { params })

export const registerMember = params => Http.get(userPath + '/userapp/registerMember.json', { params })

export const bindingWeChat = params => Http.get(userPath + '/userapp/bindingWeChat.json', { params })
